import { useCallback } from 'react';
import type { Component } from '@wix/cli-app-manifest';
import { useProjectModel } from '../../model.js';

type ComponentType = Component['compType'];

export function useExtensions() {
  const { model } = useProjectModel();

  const getExtensions = useCallback(
    <T extends ComponentType>(
      extensionType: T
    ): Array<Extract<Component, { compType: T }>> =>
      model.components.filter(
        (component): component is Extract<Component, { compType: T }> =>
          component.compType === extensionType
      ),
    [model.components]
  );

  return {
    getExtensions,
  };
}
